import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import { AccountUserAdapter } from '@/adapters';
import type {
  ApiResponse,
  AccountUserResponseDto,
  AccountUserAliasDto,
  AddAccountUserAliasDto,
  AccountUserAlias
} from '@/types';

function aliasFromApi(dto: AccountUserAliasDto): AccountUserAlias {
  return {
    id: dto.id,
    accountUserId: dto.account_user_id,
    accountId: dto.account_id,
    email: dto.email,
    createdAt: dto.created_at,
    updatedAt: dto.updated_at
  };
}

export const accountUsersService = {
  async getAccountUsers() {
    const response = await api.get<ApiResponse<AccountUserResponseDto[]>>(API_ENDPOINTS.ACCOUNT_USERS.BASE);
    return AccountUserAdapter.fromApiList(response.data.data);
  },

  async addAccountUser(name: string, email: string, role: number) {
    const payload = AccountUserAdapter.toCreateRequest(name, email, role);
    const response = await api.post<ApiResponse<AccountUserResponseDto | null>>(API_ENDPOINTS.ACCOUNT_USERS.BASE, payload);
    if (!response.data.data) return null;
    return AccountUserAdapter.fromApi(response.data.data);
  },

  async getAccountUsersForAccount(accountId: string) {
    const response = await api.get<ApiResponse<AccountUserResponseDto[]>>(API_ENDPOINTS.ACCOUNTS.USERS(accountId));
    return AccountUserAdapter.fromApiList(response.data.data);
  },

  async listAliases(accountUserId: number): Promise<AccountUserAlias[]> {
    const response = await api.get<ApiResponse<AccountUserAliasDto[]>>(
      API_ENDPOINTS.ACCOUNT_USERS.ALIASES(accountUserId)
    );
    return response.data.data.map(aliasFromApi);
  },

  async addAlias(accountUserId: number, email: string): Promise<AccountUserAlias> {
    const payload: AddAccountUserAliasDto = { email };
    const response = await api.post<ApiResponse<AccountUserAliasDto>>(
      API_ENDPOINTS.ACCOUNT_USERS.ALIASES(accountUserId),
      payload
    );
    return aliasFromApi(response.data.data);
  },

  async removeAlias(accountUserId: number, aliasId: number): Promise<void> {
    await api.delete<ApiResponse<null>>(API_ENDPOINTS.ACCOUNT_USERS.ALIAS_BY_ID(accountUserId, aliasId));
  }
};
